document.addEventListener('DOMContentLoaded', function () {
  var menuButton = document.querySelector('[data-bdr-toggle-menu]');
  var menu = document.getElementById('bdr-nav');
  if (menu && menuButton) {
    menuButton.addEventListener('click', function() {
      var open = menu.classList.toggle('is-open');
      menuButton.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
  var select = document.querySelector('[data-bdr-variant-select]');
  var price = document.querySelector('[data-bdr-product-price]');
  if (select && price) {
    select.addEventListener('change', function() {
      var option = select.options[select.selectedIndex];
      if (option) {
        price.textContent = option.getAttribute('data-price') || price.textContent;
        var url = new URL(window.location.href);
        url.searchParams.set('variant', select.value);
        history.replaceState({}, '', url.toString());
      }
    });
  }
  var main = document.querySelector('#bdr-primary-product-image');
  if (main) {
    document.querySelectorAll('[data-bdr-img]').forEach(function(button) {
      button.addEventListener('click', function() {
        main.src = button.getAttribute('data-bdr-img');
      });
    });
  }
});
